import { render, staticRenderFns } from "./add-import-modal.vue?vue&type=template&id=4f474710&scoped=true&"
import script from "./add-import-modal.vue?vue&type=script&lang=js&"
export * from "./add-import-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-import-modal.vue?vue&type=style&index=0&id=4f474710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f474710",
  null
  
)

export default component.exports